import React from 'react'

// MUI Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@mui/material'

const ConfirmationModal = (props) => {
  const {
    open,
    close,
    loading,
    submit,
    title,
    subTitle,
    text,
    submitText,
    cancelText,
    submitBtnColor
  } = props

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={close}
      maxWidth="sm"
      scroll='body'
      sx={{ '& .MuiDialog-paper': { overflow: 'visible' } }}
    >
      <DialogTitle>
        {title}
        {subTitle && (
          <Typography variant="subtitle1" component="div" sx={{ mt: 1, fontWeight: 600 }}>
            {subTitle}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={close}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 2 }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={submit}
          variant="contained"
          color={submitBtnColor || 'primary'}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} /> : null}
          autoFocus
          sx={{ borderRadius: 2 }}
        >
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
